import React, { useEffect } from 'react';
import { Row } from 'antd';
import errorImg from '../assets/images/500.svg';
import * as Sentry from '@sentry/browser';

const ServerError = ({ err }) => {
    useEffect(() => {
        Sentry.init({
            dsn: process.env.REACT_APP_PUBLIC_SENTRY_DSN,
            beforeSend: function (event, hint) {
                Sentry.showReportDialog({ eventId: event.event_id });
                return event;
            },
        });
        Sentry.captureException(err);
    }, []);

    return (
        <div className="contactUsContainer">
            <Row justify="center">
                <div className="ant-result ant-result-404">
                    <div className="ant-result-icon ant-result-image">
                        <img src={errorImg} width="252" height="294" alt="Not Found" />
                    </div>
                </div>
            </Row>
        </div>
    );
};

export default ServerError;
